const copyTextToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    try {
      // for older browsers like IE
      document.execCommand('copy', true, text);
    } catch {
      return 'Failed to copy';
    }
  }

  return 'Link copied!';
};

/**
 * A hook that allows you to copy the page location to the user's clipboard
 * @param hash Optional hash id string to link directly to a specific section on the page
 * @returns An object with:
 * - `handleCopy`: the function to pass into event handlers
 * - `pseudoStyle`: an object with quark styles to pass into before/after pseudo-element to display the copy confirmation message
 */
const UseSharePage = async (value: string) => {
  await copyTextToClipboard(value);
};

export default UseSharePage;
